const Event = (sender) => {
  const _sender = sender;
  const _listeners = [];
  return {
    attach: function(listener) {
      _listeners.push(listener);
    },
    notify: function(args) {
      _listeners.forEach(listener => {
        listener(args, _sender);
      })
    },
    getListeners: () => _listeners
  }
}

const EventAttacher = (eventHandlers) => {
  return {
    attachEvent: (event, handlerName) => {
      event.attach(eventHandlers[handlerName]);
    }
  }
}

function isValid(str) {
    return !/[~`!#$%\^&*+=\\[\]\\';/{}|\\":<>\?]/g.test(str);
}